import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import "./Blog.css"

class Blog extends Component {
  render() {
    return (
    <>
       <div className="Page">
         <div className="PageContainer">
          <h1 className="PageHeading">Blog</h1>
          <section className="Card BlogComingSoon" aria-labelledby="blog-coming-soon">
            <h2 id="blog-coming-soon" className="BlogComingSoonTitle">Coming Soon</h2>
            <p className="BlogComingSoonText">
              I'll be sharing what I learn through projects, troubleshooting, and
              hands-on experience in my homelab.
            </p>
          </section>
         </div>
        </div>
      </>
    );
  }
}

export default Blog;
